export enum FundraisingDocumentTemplatePath {
  PV_EXERCICE_PRIVATE = 'fundraising/private/pv_exercice.hbs',
  PV_EXERCICE_CROWDFUNDING = 'fundraising/crowdfunding/pv_exercice.hbs',
  PV_CONSTATATION = 'fundraising/pv_constatation.ejs',
  SUBSCRIPTION = 'fundraising/subscription.hbs',
  IBAN = 'fundraising/iban.pdf',
  OWNERSHIP_CERTIFICATE = 'fundraising/ownership_certificate.hbs',
  PEA_PME_CERTIFICATE = 'fundraising/pea_pme_certificate.hbs',
  PEA_CERTIFICATE = 'fundraising/pea_certificate.hbs',
  IR_PME_CERTIFICATE = 'fundraising/ir_pme_certificate.hbs',
}
